import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { describirError } from '../services/api';
import midasLogo from '../assets/branding/midas-logo.png';
import '../styles/Login.css';

export default function Login() {
  const [identificador, setIdentificador] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const from = location.state?.from?.pathname || '/dashboard';

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!identificador.trim() || !password) {
      setErrorMsg('Por favor ingrese su usuario y contraseña');
      return;
    }

    try {
      setSubmitting(true);
      setErrorMsg('');
      await login({ identificador: identificador.trim(), password });
      navigate(from, { replace: true });
    } catch (err) {
      const parsed = describirError(err);
      setErrorMsg(parsed.mensaje || 'Error al iniciar sesión');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-glow-1" />
      <div className="login-glow-2" />

      <div className="login-card">
        <div className="login-header">
          <div className="login-logo-wrapper">
            <img
              src={midasLogo}
              alt="Logo Oficial Sistema MIDAS"
              className="login-official-logo"
            />
          </div>
          <h1 className="login-title">SISTEMA MIDAS</h1>
          <p className="login-subtitle">Control Operativo y Financiero</p>
        </div>

        {errorMsg && (
          <div className="login-error-alert" role="alert">
            <span style={{ fontSize: '1.1rem' }}>⚠️</span>
            <div>{errorMsg}</div>
          </div>
        )}

        <form className="login-form" onSubmit={handleSubmit}>
          <div className="login-field-group">
            <label className="login-label" htmlFor="login-identificador">
              Usuario o Correo
            </label>
            <div className="login-input-wrapper">
              <input
                id="login-identificador"
                type="text"
                className="login-input"
                placeholder="ej. admin@midas.local o admin"
                value={identificador}
                onChange={(e) => setIdentificador(e.target.value)}
                autoComplete="username"
                autoFocus
                disabled={submitting}
              />
            </div>
          </div>

          <div className="login-field-group">
            <label className="login-label" htmlFor="login-password">
              Contraseña
            </label>
            <div className="login-input-wrapper">
              <input
                id="login-password"
                type={showPassword ? 'text' : 'password'}
                className="login-input"
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
                disabled={submitting}
              />
              <button
                type="button"
                className="login-password-toggle"
                onClick={() => setShowPassword(!showPassword)}
                aria-label={showPassword ? 'Ocultar contraseña' : 'Ver contraseña'}
                tabIndex="-1"
              >
                {showPassword ? '🙈' : '👁️'}
              </button>
            </div>
          </div>

          <button
            id="btn-iniciar-sesion"
            type="submit"
            className="login-submit-btn"
            disabled={submitting}
          >
            {submitting ? (
              <>
                <span className="login-spinner" />
                Iniciando sesión...
              </>
            ) : (
              'Ingresar al Sistema'
            )}
          </button>
        </form>

        <div className="login-footer">
          <p className="login-footer-title">Acceso seguro · MIDAS</p>
          <p className="login-footer-sub">Tus acciones quedan registradas para control y auditoría.</p>
        </div>
      </div>
    </div>
  );
}
